import React from 'react';
import 'chart.js/auto';
import { Bar } from 'react-chartjs-2'
import { Chart, Title } from "chart.js";

//import classes from './Card.module.css';

const BarChart = (props) => {
    Chart.register(Title);
    //ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement);

    return (
        <div>
            <Bar key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
            />
        </div>
    );
};

export default BarChart;
